<div class="resize-image">
    <a href="#" (click)="resizeImage($event)">Resize Image</a>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.rezise/image.resize.component.html